module.exports = __webpack_public_path__ + "img/footer.f306d14d.png";